import { render, staticRenderFns } from "./Comp58t2.vue?vue&type=template&id=07970c8e&scoped=true&"
import script from "./Comp58t2.vue?vue&type=script&lang=js&"
export * from "./Comp58t2.vue?vue&type=script&lang=js&"
import style0 from "./Comp58t2.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Comp58t2.vue?vue&type=style&index=1&id=07970c8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07970c8e",
  null
  
)

export default component.exports